module.exports = {
  appDirectory: "client-management",
  baseAPIUrl: "https://api.kontist.com",
  clientId: "fe8055d9-f496-49e9-9551-5b416139630e",
  redirectUri: "https://kontist.dev/client-management/"
};
